export const sortFields = ['id', 'name', 'formula', 'createdAt', 'updatedAt'] as const;
